import React, { useEffect } from "react";
import useCategory from "../hooks/useCategory";
import useNature from "../hooks/useNature";
import FormField from "./FormField";
import { Box, Checkbox, Typography } from "@mui/material";
import useAuth from "../hooks/useAuth";
const CompanyFilter = ({
  selectedCategories,
  setSelectedCategories,
  selectedNature,
  setselectedNature,
  accurate,
  setAccurate,
}) => {
  const { natures, fetchNatures } = useNature();
  const { fetchCategories, categories } = useCategory();
  const {isAdmin } = useAuth()
  useEffect(() => {
    if (selectedCategories) fetchCategories({ hide: ["Default"] });
    if (selectedNature) fetchNatures({ hide: ["Default"] });
  }, []);

  return (
    <div className="d-flex gap-3" style={{ width: "100%", flexWrap:'wrap' }}>
      <FormField
        item={{
          selected: selectedCategories,
          menuItems: categories,
          setSelected: setSelectedCategories,
          type: "multiSelect",
          label: "Select Categories",
          style: { width: {
            xs:'auto',
            sm:'auto',
            md:"auto",
            lg:"280px"
          } },
          isScreen: true,
        }}
      />
      {isAdmin && <FormField
        item={{
          selected: selectedNature,
          menuItems: natures,
          setSelected: setselectedNature,
          type: "multiSelect",
          label: "Select Industries",
          // style: { width: "280px" },
          style: { width: {
            xs:'auto',
            sm:'auto',
            md:"auto",
            lg:"280px"
          } },
          isScreen: true,
        }}
      />}
      {isAdmin &&  <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Checkbox checked={accurate} onChange={(e)=> setAccurate(e.target.checked)} />
        <Typography>Accurate</Typography>
      </Box>}
    </div>
  );
};

export default CompanyFilter;
